import React, { useState, useEffect } from 'react';
import leadService from '../../../services/lead.service';
import '../../../styles/admin-dashboard.css';

const LeadsList = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchLeads();
    }, []);

    const fetchLeads = async () => {
        try {
            setLoading(true);
            const response = await leadService.getLeads();
            if (response.success) {
                setLeads(response.data);
            }
        } catch (error) {
            console.error('Error fetching leads:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const filteredLeads = leads.filter(lead => 
        (lead.name?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (lead.email?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (lead.subject?.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    if (loading) {
        return (
            <div className="admin-content-v2">
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Loading inquiries...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-content-v2">
            <div className="diagnosis-header-v2">
                <h1 className="nav-title-v2">Inquiries & Leads</h1>
                <p className="nav-subtitle-v2">Manage all customer inquiries from Insurance and Contact pages</p>
            </div>

            <div className="table-card-v2">
                <div className="table-card-header-v2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Recent Submissions</h3>
                    <div className="search-wrapper-v2" style={{ margin: 0, maxWidth: '300px' }}>
                        <input
                            type="text"
                            className="search-input-v2"
                            placeholder="Search leads..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="v2-table">
                        <thead>
                            <tr>
                                <th>Name & Contact</th>
                                <th>Inquiry Type / Subject</th>
                                <th>Message</th>
                                <th>Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredLeads.length > 0 ? (
                                filteredLeads.map((lead) => (
                                    <tr key={lead.id}>
                                        <td>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span style={{ fontWeight: 600, color: 'var(--admin-v2-primary)' }}>{lead.name}</span>
                                                <span style={{ fontSize: '12px', color: 'var(--admin-v2-text-muted)' }}>{lead.phone}</span>
                                                <span style={{ fontSize: '12px', color: 'var(--admin-v2-text-muted)' }}>{lead.email}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span 
                                                    className={`badge-v2 ${lead.subject?.toLowerCase().includes('insurance') ? 'insurance-badge' : 'general-badge'}`}
                                                    style={{ 
                                                        fontSize: '11px', 
                                                        fontWeight: 700, 
                                                        padding: '4px 8px', 
                                                        borderRadius: '4px',
                                                        display: 'inline-block',
                                                        marginBottom: '4px',
                                                        width: 'fit-content',
                                                        backgroundColor: lead.subject?.toLowerCase().includes('insurance') ? '#E0F2FE' : '#F1F5F9',
                                                        color: lead.subject?.toLowerCase().includes('insurance') ? '#0369A1' : '#475569'
                                                    }}
                                                >
                                                    {lead.subject?.toLowerCase().includes('insurance') ? 'INSURANCE' : 'GENERAL'}
                                                </span>
                                                <span style={{ fontWeight: 500 }}>{lead.subject}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <p style={{ margin: 0, fontSize: '13px', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {lead.message}
                                            </p>
                                        </td>
                                        <td>
                                            <span style={{ fontSize: '12px' }}>{formatDate(lead.createdAt)}</span>
                                        </td>
                                        <td>
                                            <span 
                                                style={{ 
                                                    padding: '4px 10px', 
                                                    borderRadius: '20px', 
                                                    fontSize: '11px', 
                                                    fontWeight: 700,
                                                    background: '#DCFCE7',
                                                    color: '#166534'
                                                }}
                                            >
                                                {lead.status?.toUpperCase() || 'NEW'}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: '#64748B' }}>
                                        No inquiries found matching your search.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default LeadsList;
